import React from 'react';
import { XIcon } from 'lucide-react';
interface SidePanelProps {
  open: boolean;
  title: string;
  onClose: () => void;
  action?: React.ReactNode;
  children: React.ReactNode;
  sheet?: React.ReactNode;
}
export function SidePanel({
  open,
  title,
  onClose,
  action,
  children,
  sheet
}: SidePanelProps) {
  if (!open) return null;
  return <div className="fixed inset-0 z-40 flex justify-end" role="dialog" aria-modal="true" aria-label={title} data-id="element-376" data-mp="2n845x2pgga39">
      <button type="button" aria-label="Close panel" onClick={onClose} className="absolute inset-0 bg-white/70" data-id="element-377" data-mp="3173r20dre6uo" />
      <aside className="relative flex h-full w-full max-w-[420px] flex-col border-l border-ink-200 bg-white shadow-panel" data-id="element-378" data-mp="3az9mjk37z6em">
        <header className="flex items-center justify-between gap-3 px-5 py-4" data-id="element-379" data-mp="360gi0h5wupql">
          <div className="flex min-w-0 items-center gap-3" data-id="element-380" data-mp="3ky8t8x4fcryz">
            <button type="button" onClick={onClose} aria-label="Close panel" className="rounded text-ink-700 hover:text-ink-900" data-id="element-381" data-mp="3fy30teqbz1fu">
              <XIcon className="h-[18px] w-[18px]" data-id="element-382" data-mp="2k5rwbse7bn7e" />
            </button>
            <h2 className="truncate text-[16px] font-bold text-ink-900" data-id="element-383" data-mp="2k7vvjx15ny1c">{title}</h2>
          </div>
          {action}
        </header>
        <div className="flex-1 overflow-y-auto" data-id="element-384" data-mp="2t67xuwbdwk9m">{children}</div>
        {sheet}
      </aside>
    </div>;
}
export function PanelRow({
  label,
  value
}: {
  label: string;
  value: React.ReactNode;
}) {
  return <div className="grid grid-cols-[130px_1fr] items-start gap-4 px-5 py-[7px]" data-id="element-385" data-mp="33442d59tggyr">
      <dt className="text-[13px] text-ink-500" data-id="element-386" data-mp="37vci0j1qoykd">{label}</dt>
      <dd className="min-w-0 break-words text-[13px] font-medium text-ink-900" data-id="element-387" data-mp="37vvuvlcj8wrj">{value}</dd>
    </div>;
}
interface BottomSheetProps {
  title: string;
  onCancel: () => void;
  onSave: () => void;
  children: React.ReactNode;
}
export function BottomSheet({
  title,
  onCancel,
  onSave,
  children
}: BottomSheetProps) {
  return <div className="absolute inset-x-0 bottom-0 z-10 max-h-[70%] overflow-y-auto border-t border-ink-200 bg-white" data-id="element-388" data-mp="1lsvqk3g6g5yb">
      <h3 className="px-5 pb-1 pt-5 text-[15px] font-bold text-ink-900" data-id="element-389" data-mp="1gu2kux74tj8p">{title}</h3>
      <div className="space-y-4 px-5 py-4" data-id="element-390" data-mp="1vip0l00o8d0g">{children}</div>
      <div className="sticky bottom-0 flex items-center justify-end gap-3 bg-white px-5 py-4" data-id="element-391" data-mp="1vk9x2v6jq60y">
        <button type="button" onClick={onCancel} className="h-9 rounded px-3 text-[13px] font-medium text-ink-700 hover:bg-ink-100" data-id="element-392" data-mp="1qqe281lkwza0">
          Cancel
        </button>
        <button type="button" onClick={onSave} className="h-9 rounded bg-brand-600 px-4 text-[13px] font-semibold text-white hover:bg-brand-700" data-id="element-393" data-mp="20h8nb2n39stv">
          Save Changes
        </button>
      </div>
    </div>;
}